import POIPinLarge from './POIPinLarge';

export default POIPinLarge;
